export interface IntroScreen {
  element: HTMLElement;
  startButton: HTMLButtonElement;
  hide(): void;
  show(): void;
  setBusy(busy: boolean): void;
  setStartButtonLabel(label: string): void;
}

export function createIntroScreen(onStart: () => void): IntroScreen {
  const element = document.createElement("section");
  element.className = "intro-screen";
  element.setAttribute("aria-labelledby", "intro-title");

  const brand = document.createElement("p");
  brand.className = "intro-screen__brand";
  brand.textContent = "Converto";

  const title = document.createElement("h1");
  title.id = "intro-title";
  title.className = "intro-screen__title";
  title.textContent = "Descubra a Converto em realidade aumentada";

  const text = document.createElement("p");
  text.className = "intro-screen__text";
  text.textContent = "Aponte a câmara para o cartão para iniciar a experiência.";

  const startButton = document.createElement("button");
  startButton.className = "button button--primary intro-screen__button";
  startButton.type = "button";
  startButton.textContent = "Iniciar experiência";
  startButton.addEventListener("click", onStart);

  const privacy = document.createElement("p");
  privacy.className = "intro-screen__privacy";
  privacy.textContent =
    "A câmara é utilizada apenas para reconhecer o cartão. Nenhuma imagem é gravada ou enviada.";

  const targetPreview = document.createElement("img");
  targetPreview.className = "intro-screen__target";
  targetPreview.src = "/assets/targets/converto-card.jpg";
  targetPreview.alt = "Cartão Converto de demonstração";
  targetPreview.loading = "eager";

  const content = document.createElement("div");
  content.className = "intro-screen__content";
  content.append(brand, title, text, startButton, privacy);

  const visual = document.createElement("div");
  visual.className = "intro-screen__visual";
  visual.append(targetPreview);

  element.append(content, visual);

  return {
    element,
    startButton,
    hide(): void {
      element.classList.add("intro-screen--hidden");
      element.setAttribute("aria-hidden", "true");
    },
    show(): void {
      element.classList.remove("intro-screen--hidden");
      element.removeAttribute("aria-hidden");
    },
    setBusy(busy: boolean): void {
      startButton.disabled = busy;
      startButton.setAttribute("aria-busy", String(busy));
    },
    setStartButtonLabel(label: string): void {
      startButton.textContent = label;
    },
  };
}
